import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import classes from "./Modal.module.css";

import back from "../../../images/back.png"

import gsap from "gsap";

const Modal = (props) => {
  const circle = useRef(null);
  const circleContainer = useRef(null);
  const modal = useRef(null);
  let containerClass = classes.container;
  if (props.mobile) {
    console.log("MODAL MOBILE");
    containerClass = classes.containerMobile;
  } else {
    containerClass = classes.container;
  }

  useEffect(() => {
    var e = window.event;

    var posX = e.clientX;
    var posY = e.clientY;
    const X = modal.current.getBoundingClientRect().x;
    const Y = modal.current.getBoundingClientRect().y;

    modal.current.style.setProperty("--circleTop", `${-(Y - posY)}px`);
    modal.current.style.setProperty("--circleLeft", `${-(X - posX)}px`);
    modal.current.style.setProperty("--circleWidth", `${props.circle}px`);

    gsap.from(modal.current, {
      duration: 1.5,
      yPercent: -10,
      ease: "elastic",
    });
    gsap.to(modal.current, {
      delay: 0.5,
      duration: 1,
      boxShadow: "0px 0px 0px 1000px rgba(0,0,0,0.5)",
    });
    gsap.to(modal.current, {
      delay: 0.5,
      duration: 0.5,
      onStart: () => {
        if (modal.current != undefined) {
          modal.current.style.setProperty("--modalOpacity", `1`);
        }
      },
    });
  }, []);

  return ReactDOM.createPortal(
    <div className={classes.backdrop}>
      <div className={classes.backdrop} onClick={props.cancel}></div>
      <div className={containerClass} ref={modal}>
        <div className={classes.title}>
          {props.mobile && (
            <div className={classes.item} onClick={props.cancel}>
              <img src={back} alt={"Back"}/>
            </div>
          )}
          {props.title}
          {props.mobile && <div className={classes.item}></div>}
        </div>
        <div className={classes.form}>{props.children}</div>
      </div>
    </div>,
    document.getElementById("portal")
  );
};
export default Modal;
